import { ActionList, Button, Icon, Link, Modal, Popover, Text, TextField, Tooltip } from "@shopify/polaris"
import {
  ArrowRightIcon,
  ChatIcon,
  ClipboardIcon,
  DuplicateIcon,
  GiftCardIcon,
  HeartIcon,
  IconsFilledIcon,
  RewardIcon,
  ShareIcon,
  XIcon,
} from "@shopify/polaris-icons"
import copy from "copy-to-clipboard"
import { Observer } from "mobx-react"
import React, { useCallback, useEffect, useState } from "react"
import { Trans, useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useIntercom } from "react-use-intercom"

import { ShareUrl, SharingIcons } from "@/component/SharingBanner/SharingBanner"
import { LINK_BOOK_A_DEMO } from "@/consts/link"
import { CROSS_SELL_POINT_ENUM } from "@/enums/CrossSellPoint"
import { SpecialOfferType } from "@/models/IUserInfo"
import { ContactGroup } from "@/pages/Dashboard/components/ContactGroup"
import stores from "@/stores"
import MonorailTracker from "@/utils/monorailTracker"
import { openLink } from "@/utils/redirectShopify"
import toast from "@/utils/toast"

import styles from "./index.module.scss"

enum PopupType {
  FreeQuota = "FreeQuota",
  RemoveBrand = "RemoveBrand",
  RecommendFriends = "RecommendFriends",
  PartnerFriendly = "PartnerFriendly",
  CrossSell = "CrossSell",
  Dismiss = "Dismiss",
}

const SpecialOffer = () => {
  const { showNewMessage } = useIntercom()
  const { userInfoSore, commonStore } = stores
  const [showPopover, setShowPopover] = useState(false)
  const { t } = useTranslation("dashboard")
  const { t: commonT } = useTranslation("common")

  const [popupStates, setPopupStates] = useState<Record<PopupType, boolean>>({
    [PopupType.FreeQuota]: false,
    [PopupType.RemoveBrand]: false,
    [PopupType.RecommendFriends]: false,
    [PopupType.PartnerFriendly]: false,
    [PopupType.CrossSell]: false,
    [PopupType.Dismiss]: false,
  })

  const togglePopup = (type: PopupType) => {
    if (showPopover) setShowPopover(false)
    setPopupStates((prevStates) => ({
      ...prevStates,
      [type]: !prevStates[type], // 切换当前弹窗的状态
    }))
  }


  let text_message = ""
  const checkT = userInfoSore.data.is_show_partner_friendly_banner ?? 0

  if (checkT === 1) {
    text_message = commonT("PartnerFriendlyBanner.content_1")
  }
  if (checkT === 2) {
    text_message = commonT("PartnerFriendlyBanner.content_2")
  }

  // SpecialOffer按钮点击
  const handleSpecialOfferClick = (status: SpecialOfferType) => {
    setShowPopover(!showPopover)
    if (status === SpecialOfferType.ShowAll)
      userInfoSore.setSpecialOffer(SpecialOfferType.ShowButton)
  }

  const activator = <Observer>{() => {
    const { special_offer } = userInfoSore.data

    if (special_offer === SpecialOfferType.Hidden){
      return null
    }

    return <div className={"Polaris-ActionMenu-SecondaryAction relative"}>
      {/* {special_offer === SpecialOfferType.ShowAll && <PolarisIndicator />} */}
      <Button variant={"secondary"} icon={GiftCardIcon} disclosure onClick={() => handleSpecialOfferClick(special_offer)}>
        {t("SpecialOffer")}
      </Button>
    </div>
  }}</Observer>

  // 联系额度翻倍
  const handleMessageDoubleQuota = (e:any) => {
    e && e.stopPropagation()
    showNewMessage(t("freeQuotaBanner.concatUsMsg"))
    setShowPopover(false)
  }
  // 联系Remove branding
  const handleDeleteBranding = (e:any) => {
    e && e.stopPropagation()
    showNewMessage(t("RemoveBranding"))
    setShowPopover(false)
  }

  const [popoverActive, setPopoverActive] = useState(false)

  const togglePopoverActive = useCallback(
    () => setPopoverActive((popoverActive) => !popoverActive),
    [],
  )

  useEffect(() => {
    if (showPopover){
      window.CrossSellTracker?.logViewed(CROSS_SELL_POINT_ENUM.SpecialOfferProtection)
      window.CrossSellTracker?.logViewed(CROSS_SELL_POINT_ENUM.SpecialOfferReturn)

      MonorailTracker.trackSupportPartnerViewed(0)
    }
  }, [showPopover])

  useEffect(() => {
    if (popupStates.CrossSell){
      window.CrossSellTracker?.logViewed(CROSS_SELL_POINT_ENUM.SpecialOfferContact)
    }
  }, [popupStates.CrossSell])

  return <Observer>{() => {
    const { showPartnerFriendly, showRemoveBrandingBanner, data: {
      cross_sell_eligible,
    } } = stores.userInfoSore
    const navigator = useNavigate()
    const showFreeAdd =  userInfoSore.data.show_double_free_quota_tip
    const checkT = userInfoSore.data.is_show_partner_friendly_banner ?? 0

    // 设置预览模式，该模式下所有的Item都显示
    const isPreview = false

    return <>
      <Popover
        preferredAlignment={"right"}
        active={showPopover}
        activator={activator}
        fullHeight
        onClose={() => setShowPopover(false)}
      >
        <div className={styles.actionWrapper}>
          <div className={"pt-2 pb-0.5 px-3"}>
            <Text as={"p"} variant="headingSm">CWILL Tracking</Text>
          </div>
          <ActionList
            actionRole="menuitem"
            items={[
              cross_sell_eligible || isPreview ?
                {
                  icon: ChatIcon,
                  content: t("SpecialOfferListCrossSell.title"),
                  helpText: t("SpecialOfferListCrossSellDesc"),
                  suffix: <Icon source={ArrowRightIcon} tone={"primary"} />,
                  onAction() {
                    togglePopup(PopupType.CrossSell)
                  },
                } : undefined,

              // showFreeAdd  || isPreview ?
              //   {
              //     icon: DuplicateIcon,
              //     content: t("SpecialOfferList1.title") + " 🔥",
              //     helpText: <Trans ns="dashboard" i18nKey="SpecialOfferList1.helpText">
              //       {/* @ts-ignore*/}
              //       <Link removeUnderline onClick={handleMessageDoubleQuota} />
              //     </Trans>,
              //     suffix: <Icon source={ArrowRightIcon} tone={"primary"} />,
              //     onAction() {
              //       // togglePopup(PopupType.FreeQuota)
              //       if (showPopover) setShowPopover(false)
              //       showNewMessage(t("freeQuotaBanner.concatUsMsg"))
              //     },
              //   } : undefined,
              // showRemoveBrandingBanner || isPreview ?
              //   {
              //     icon: IconsFilledIcon,
              //     content: commonT("Remove") + " “Powered by CWILL”  🔥",
              //     helpText: <Trans ns="dashboard" i18nKey="SpecialOfferList2.helpText">
              //       {/* @ts-ignore*/}
              //       <Link removeUnderline onClick={handleDeleteBranding} />
              //     </Trans>,
              //     suffix: <Icon source={ArrowRightIcon} tone={"primary"} />,
              //     onAction() {
              //       // togglePopup(PopupType.RemoveBrand)
              //       if (showPopover) setShowPopover(false)
              //       showNewMessage(t("RemoveBranding"))
              //     },
              //   } : undefined,
              userInfoSore.showSharingBanner || isPreview ?
                {
                  icon: ShareIcon,
                  content: t("SpecialOfferList3.title"),
                  helpText: t("SpecialOfferList3.helpText"),
                  suffix: <Icon source={ArrowRightIcon} tone={"primary"} />,
                  onAction() {
                    togglePopup(PopupType.RecommendFriends)
                  },
                } : undefined,
              showPartnerFriendly || isPreview ?
                {
                  icon: HeartIcon,
                  content: checkT === 1 ? t("SpecialOfferList4.title") : t("SpecialOfferList4.title2"),
                  helpText: checkT === 1 ? t("SpecialOfferList4.helpText") : t("SpecialOfferList4.helpText2"),
                  suffix: <Icon source={ArrowRightIcon} tone={"primary"} />,
                  onAction() {
                    togglePopup(PopupType.PartnerFriendly)
                  },
                } : undefined,
            ].filter(item => item)}
          />

          <div className={"pt-1 pb-0.5 px-3"}>
            <Text as={"p"} variant="headingSm">CWILL Post-purchase</Text>
          </div>

          <ActionList
            actionRole="menuitem"
            items={[
              {
                prefix: <div className={"w-5 h-5 rounded-sm overflow-hidden"}>
                  <img className={"w-full h-full"} src={"https://cdn.parcelpanel.com/front-end/2026/CWILL.svg"} alt={"return-icon"} />
                </div>,
                content: "CWILL Returns & Exchanges",
                helpText: t("SpecialOfferList5HelpText"),
                suffix: <Icon source={ArrowRightIcon} tone={"primary"} />,
                onAction() {
                  setShowPopover(false)
                  window.CrossSellTracker?.redirectToReturnInstall(CROSS_SELL_POINT_ENUM.SpecialOfferReturn, {
                    from: "parcelpanel",
                  })
                },
              },
              {
                prefix: <div className={"w-5 h-5 rounded-sm overflow-hidden"}>
                  <img className={"w-full h-full"} src={"https://cdn.parcelpanel.com/front-end/2026/CWILL.svg"} alt={"ppi-icon"} />
                </div>,
                content: "CWILL Shipping Protection",
                helpText: t("SpecialOfferList6HelpText"),
                suffix: <Icon source={ArrowRightIcon} tone={"primary"} />,
                onAction() {
                  window.CrossSellTracker?.logClicked(CROSS_SELL_POINT_ENUM.SpecialOfferProtection)
                  // 跳转PP insurance前，将traceId存储到sessionStorage，避免刷新后丢失
                  sessionStorage.setItem("crossSellToInsuranceTraceId", window.CrossSellTracker?.getTraceId() || "")
                  navigator("/protection")
                },
              },
            ].filter(item => item)}
          />

          <div className={"pt-1 pb-0.5 px-3"}>
            <Text as={"p"} variant="headingSm">CWILL Partner</Text>
          </div>

          <ActionList
            actionRole="menuitem"
            items={[
              // commonStore.recommendAppsPartnersData.find(item => item.id === 1) ?
              //   {
              //     icon: RewardIcon,
              //     content: t("SpecialOfferList7title"),
              //     helpText: t("SpecialOfferList7HelpText"),
              //     suffix: <Icon source={ArrowRightIcon} tone={"primary"} />,
              //     onAction() {
              //       setShowPopover(false)
              //       openLink("https://chrome-poppyseed-314.notion.site/2245d2e0397580258be7fd8c280b0b43?pvs=105")
              //       MonorailTracker.trackSupportPartnerClicked(1)
              //     },
              //   } : null,
              ...commonStore.recommendAppsPartnersData.filter(item => item.id !== 1).map(item => ({
                prefix: <div className={"w-5 h-5 rounded-sm overflow-hidden"}><img className={"w-full h-full"} src={item.img_url} alt={item.name} /></div>,
                content: item.name,
                helpText: item.description,
                suffix: <Icon source={ArrowRightIcon} tone={"primary"} />,
                onAction() {
                  setShowPopover(false)
                  item.url && openLink(item.url)
                  // 埋点
                  MonorailTracker.trackSupportPartnerClicked(item.id)
                },
              })),
              {
                icon: XIcon,
                content: t("dismiss"),
                destructive: true,
                onAction() {
                  togglePopup(PopupType.Dismiss)
                },
              },
            ].filter(item => item)}
          />
        </div>
      </Popover>


      <Modal
        open={popupStates.FreeQuota}
        onClose={() => togglePopup(PopupType.FreeQuota)}
        title={t("SpecialOfferList1.modalTitle")}
        primaryAction={{
          content: t("freeQuotaBanner.action"),
          onAction: () => {
            togglePopup(PopupType.FreeQuota)
            handleMessageDoubleQuota(null)
          },
        }}
      >
        <Modal.Section>
          {t("SpecialOfferList1.description")}
        </Modal.Section>
      </Modal>

      <Modal
        open={popupStates.RemoveBrand}
        onClose={() => togglePopup(PopupType.RemoveBrand)}
        title={t("SpecialOfferList2.modalTitle")}
        primaryAction={{
          content: t("freeQuotaBanner.action"),
          onAction: () => {
            togglePopup(PopupType.RemoveBrand)
            handleDeleteBranding(null)
          },
        }}
      >
        <Modal.Section>
          {t("SpecialOfferList2.description")}
        </Modal.Section>
      </Modal>

      <Modal
        open={popupStates.RecommendFriends}
        onClose={() => togglePopup(PopupType.RecommendFriends)}
        title={t("SpecialOfferList3.title")}
        secondaryActions={[{
          content: commonT("Close"),
          onAction: () => {
            togglePopup(PopupType.RecommendFriends)
          },
        }]}
      >
        <Modal.Section>
          {t("SpecialOfferList3.description")}
          <div className={"mt-1 flex gap-2 items-center"}>
            <div className={"w-[400px] max-w-[80%]"}>
              <TextField label={""} autoComplete={""} readOnly value={ShareUrl} />
            </div>

            <Tooltip content={commonT("CopyLink")} dismissOnMouseOut>
              <Button icon={ClipboardIcon} onClick={() => {
                const copyRes = copy(ShareUrl)

                toast(copyRes ? commonT("CopiedSuccessfully") : commonT("CopiedUnsuccessfully"), 2e3, !copyRes)
              }}
              />
            </Tooltip>

            <SharingIcons />

          </div>
        </Modal.Section>
      </Modal>
      <Modal
        open={popupStates.PartnerFriendly}
        onClose={() => togglePopup(PopupType.PartnerFriendly)}
        title={checkT === 1 ? t("SpecialOfferList4.title") :  t("SpecialOfferList4.title2")}
        secondaryActions={[{
          content: commonT("Close"),
          onAction: () => {
            togglePopup(PopupType.PartnerFriendly)
          },
        }]}
      >
        <Modal.Section>
          {text_message}
        </Modal.Section>
      </Modal>
      <Modal
        open={popupStates.CrossSell}
        onClose={() => togglePopup(PopupType.CrossSell)}
        title={t("CrossSellModalTitle")}
        primaryAction={{
          disclosure: true,
          content: <ContactGroup CROSS_SELL_POINT={CROSS_SELL_POINT_ENUM.SpecialOfferContact} setPopoverActive={setPopoverActive} popoverActive={popoverActive} />,
          onAction: () => {
            togglePopoverActive()
          },
        }}
        secondaryActions={[{
          content: t("BookADemo"),
          onAction() {
            const tracker = window.CrossSellTracker

            if (tracker?.redirectToDemo) {
              tracker.redirectToDemo(
                CROSS_SELL_POINT_ENUM.SpecialOfferContact,
                LINK_BOOK_A_DEMO,
              )
            } else {
              openLink(LINK_BOOK_A_DEMO)
            }
          },
        }]}
      >
        <Modal.Section>
          {t("CrossSellModalDescription")}
        </Modal.Section>
      </Modal>
      <Modal
        open={popupStates.Dismiss}
        onClose={() => togglePopup(PopupType.Dismiss)}
        title={t("SpecialOfferDismiss.title")}
        secondaryActions={[{
          content: commonT("Cancel"),
          onAction: () => {
            togglePopup(PopupType.Dismiss)
          },
        }]}
        primaryAction={{
          destructive: true,
          content: t("dismiss"),
          onAction: () => {
            togglePopup(PopupType.Dismiss)

            userInfoSore.setSpecialOffer(SpecialOfferType.Hidden)
          },
        }}
      >
        <Modal.Section>
          {t("SpecialOfferDismiss.description")}
        </Modal.Section>
      </Modal>
    </>
  }}</Observer>

}

export default SpecialOffer
